import http from '../../http';

export const fetchAutoPayoutSuggestionStatus = shopId =>
  http.get(`/shop/${shopId}/auto-payout-offer/status`);

export const acceptAutoPayoutSuggestion = (shopId, actionTaken) =>
  http.post(`/shop/${shopId}/auto-payout-offer/setup`, { action: actionTaken });

export const postponeAutoPayoutSuggestion = shopId =>
  http.post(`/shop/${shopId}/auto-payout-offer/postpone`);

export const declineAutoPayoutSuggestion = (shopId, feedback) =>
  http.post(`/shop/${shopId}/auto-payout-offer/decline`, feedback ? { feedback } : undefined);

export const resetAutoPayoutSuggestionModalState = shopId =>
  http.post(`/shop/${shopId}/auto-payout-offer/reset`);
